var map = {
	"./basme/2.jpg": "feb0",
	"./cacealma/2.jpg": "37c4",
	"./gewalt/2.jpg": "be63",
	"./jurnal-tetelu/2.jpg": "d47b",
	"./la-inceput/2.jpg": "8038",
	"./nichita/2.jpg": "9015",
	"./oaianeagra/2.jpg": "06e6",
	"./peei/2.jpg": "2902",
	"./scrisoare-tata/2.jpg": "ede8",
	"./scrisori-front/2.jpg": "d913",
	"./urletul/2.jpg": "5e8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fe3";